import {
    AppointmentState,
    ConfirmAppointmentAction,
    ShowConfirmationSectionAction,
    StageAppointmentsAction
} from "./type";

/**
 * @name confirmSelectedAppointmentHandler
 * @export
 * @param {AppointmentState} state
 * @param {ConfirmAppointmentAction} action
 * @returns {AppointmentState}
 */
export function confirmSelectedAppointmentHandler(state: AppointmentState, action: ConfirmAppointmentAction): AppointmentState {
    return Object.assign({}, state, {
        isAppointmentConfirmed: action.payload.confirmed,
        showConfirmationModal: false
    });
}

/**
 * @name showConfirmationModalHandler
 * @export
 * @param {AppointmentState} state
 * @param {ShowConfirmationSectionAction} action
 * @returns {AppointmentState}
 */
export function showConfirmationModalHandler(state: AppointmentState, action: ShowConfirmationSectionAction): AppointmentState {
    return Object.assign({}, state, {
        showConfirmationModal: action.payload.show
    });
}

/**
 * @name stageAppointmentsHandler
 * @export
 * @param {AppointmentState} state
 * @param {StageAppointmentsAction} action
 * @returns {AppointmentState}
 */
export function stageAppointmentsHandler(state: AppointmentState, action: StageAppointmentsAction): AppointmentState {
    return Object.assign({}, state, { appointments: action.payload.appointments });
}


// WEBPACK FOOTER //
// ./src/store/Appointment/handlers.ts